import { conciliacaoClient } from '../libs/conciliacao-client'

export function mapSortingBuilderValueToParam (sortingValue) {
  return `${sortingValue.direction === 'desc' ? '-' : ''}${sortingValue.value}`
}
//
const initialState = () =>
  ({
    permiteSegundaConcRegular: false,
    conciliandoGuiaAutomaticamente: false,
    conciliacaoGuias: { loading: false, error: undefined, result: undefined },
    faturamentoGuias: { loading: false, error: undefined, result: undefined },
    faturamentoGuiasSorting: [{ value: null, direction: 'asc' }],
    faturamentoGuiasFilters: {},
    faturamentoItens: { loading: false, error: undefined, result: undefined },
    faturamentoItensSorting: [{ value: null, direction: 'asc' }],
    faturamentoItensFilters: { conciliacaoItensCountEq: 0 },
    pagamentoId: null,
    pagamentoLoteId: null,
    pagamentoGuiaId: null,
    pagamentoGuia: { loading: false, error: undefined, result: undefined },
    pagamentoItens: { loading: false, error: undefined, result: undefined },
    pagamentoItensSorting: [{ value: null, direction: 'asc' }],
    pagamentoItensFilters: { conciliacaoItensCountEq: 0, conciliacaoItensCountGt: undefined },
    selectedFaturamentoGuiasFilterOption: 'nao-conciliados',
    selectedFaturamentoGuias: {},
    selectedFaturamentoItensFilterOption: 'nao-conciliados',
    selectedFaturamentoItens: {},
    selectedPagamentoItensFilterOption: 'nao-conciliados',
    selectedPagamentoItens: {},
    showFaturamentoItens: false
  })

const state = initialState()

const getters = {
  pagamentoItensQuery (state) {
    return ({
      ...state.pagamentoItensFilters,
      pagamentoGuiaId: state.pagamentoGuiaId || undefined,
      pageSize: 10000,
      sorting: state.pagamentoItensSorting
        .filter(sort => sort.value)
        .map(mapSortingBuilderValueToParam),
      includeConciliacaoItens: true
    })
  },
  isFaturamentoGuiaSelected (state) {
    return faturamentoGuiaId => Boolean(state.selectedFaturamentoGuias[faturamentoGuiaId])
  },
  isFaturamentoItemSelected (state) {
    return faturamentoItemId => Boolean(state.selectedFaturamentoItens[faturamentoItemId])
  },
  isPagamentoItemSelected (state) {
    return (pagamentoItemId) => Boolean(state.selectedPagamentoItens[pagamentoItemId])
  },
  totalFaturamentoGuias (state) {
    return state.faturamentoGuias.result?.totalSize
  },
  totalFaturamentoItens (state) {
    return state.faturamentoItens.result?.totalSize
  },
  totalPagamentoItens (state) {
    return state.pagamentoItens.result?.totalSize
  },
  selectedFaturamentoGuiasCount (state) {
    return Object.keys(state.selectedFaturamentoGuias).length
  },
  selectedFaturamentoItensCount (state) {
    return Object.keys(state.selectedFaturamentoItens).length
  },
  selectedPagamentoItensCount (state) {
    return Object.keys(state.selectedPagamentoItens).length
  },
  selectedPagamentoItensIds (state) {
    return Object.keys(state.selectedPagamentoItens)
  },
  faturamentoGuiasAssociadasIds (state) {
    return state.conciliacaoGuias.result?.data.map(conciliacao => conciliacao.faturamentoGuiaId)
  },
  isFaturamentoGuiaAssociada (state) {
    return faturamentoGuiaId => state.conciliacaoGuias.result?.data
      .map(conciliacao => conciliacao.faturamentoGuiaId)
      .includes(faturamentoGuiaId)
  },
  hasGuiasAssociadas (state) {
    return state.conciliacaoGuias.result?.totalSize > 0
  },
  isPagamentoRecurso (state) {
    return state.pagamentoItens.result?.data.some(item => item.tipoRegistro === 'recurso')
  },
  pagamentoLoteStatus (state) {
    return state.pagamentoGuia.result?.pagamentoLote?.status
  },
  pagamentoLoteResponsavel (state) {
    return state.pagamentoGuia.result?.pagamentoLote?.responsavel
  },
  hasSelectedPagamentoItemConciliado (state) {
    return Object.values(state.selectedPagamentoItens)
      .some(item => Boolean(item.conciliacaoItens?.length))
  },
  hasSelectedFaturamentoItemConciliado (state) {
    return Object.values(state.selectedFaturamentoItens)
      .some(item => Boolean(item.conciliacaoItens?.length))
  },
  hasFaturamentoItemConciliado (state) {
    return state.faturamentoItens.result?.data.some(item => Boolean(item.conciliacaoItens?.length))
  },
  isSelectedPagamentoItensRecurso (state) {
    const pagamentoItens = Object.values(state.selectedPagamentoItens)

    return pagamentoItens.length && pagamentoItens.every(item => item.tipoRegistro === 'recurso')
  },
  isSelectedPagamentoItensEstorno (state) {
    const pagamentoItens = Object.values(state.selectedPagamentoItens)

    return pagamentoItens.length && pagamentoItens.every(item => item.tipoRegistro === 'estorno')
  },
  hasSelectedItemSistema (state) {
    return Object.values(state.selectedPagamentoItens)
      .some(item => item.itemSistema)
  },
  hasItemSistema (state) {
    return state.pagamentoItens.result?.data.some(item => item.itemSistema)
  },
  selectedPagamentoItemsSistema (state) {
    return Object.values(state.selectedPagamentoItens)
      .filter(item => item.itemSistema)
  },
  selectedFaturamentoItemConciliadoDates (state) {
    return Object.values(state.selectedFaturamentoItens)
      .map(faturamentoItem => faturamentoItem.conciliacaoItens
        ?.map(conciliacaoItem => conciliacaoItem.dataPagamento)
      )
      .flat()
  }
}

const actions = {
  async pageInit ({ commit, dispatch }, payload) {
    commit('RESET_STATE', initialState())
    commit('SET_PAGAMENTO_ID', payload.pagamentoId)
    commit('SET_PAGAMENTO_LOTE_ID', payload.pagamentoLoteId)
    commit('SET_PAGAMENTO_GUIA_ID', payload.pagamentoGuiaId)
    await dispatch('getPagamentoGuia')
    await dispatch('getPagamentoItens')
    await dispatch('getFaturamentoGuias')
    await dispatch('getConciliacaoGuias')
  },
  openFaturamentoGuia ({ commit, dispatch }, payload) {
    commit('DESELECT_ALL_FATURAMENTO_GUIAS')
    commit('SELECT_FATURAMENTO_GUIA', payload)
    dispatch('getFaturamentoItens')
    commit('SET_SHOW_FATURAMENTO_ITENS', true)
  },
  openFaturamentoGuiasAssociadas ({ commit, dispatch, getters, state }) {
    const selectedGuias = state.faturamentoGuias.result?.data.length > 0
      ? state.faturamentoGuias.result?.data
          .filter(guia => getters.faturamentoGuiasAssociadasIds.includes(guia.id))
          .map(guia => [guia.id, guia])
      : state.conciliacaoGuias.result?.data.map(
          conciliacaoGuia => [conciliacaoGuia.faturamentoGuiaId, {}]
        )

    if (selectedGuias.length > 0) {
      commit('SET_SELECTED_FATURAMENTO_GUIAS', Object.fromEntries(selectedGuias))
      dispatch('getFaturamentoItens')
      commit('SET_SHOW_FATURAMENTO_ITENS', true)
    }
  },
  openFaturamentoGuiasSelecionadas ({ commit, dispatch }) {
    dispatch('getFaturamentoItens')
    commit('SET_SHOW_FATURAMENTO_ITENS', true)
  },
  backToGuias ({ commit, dispatch }) {
    dispatch('deselectAllFaturamentoItens')
    commit('SET_SHOW_FATURAMENTO_ITENS', false)
  },
  async conciliacaoItensCreated ({ commit, dispatch }) {
    await dispatch('getPagamentoGuia')
    await dispatch('getPagamentoItens')
    await dispatch('getFaturamentoItens')
    commit('DESELECT_ALL_PAGAMENTO_ITENS')
    commit('DESELECT_ALL_FATURAMENTO_ITENS')
  },
  async conciliacaoItensDeleted ({ commit, dispatch }) {
    await dispatch('getPagamentoGuia')
    await dispatch('getPagamentoItens')
    await dispatch('getFaturamentoItens')
    commit('DESELECT_ALL_PAGAMENTO_ITENS')
    commit('DESELECT_ALL_FATURAMENTO_ITENS')
  },
  async conciliarGuiaAutomaticamente ({ commit, dispatch }, payload) {
    commit('SET_CONCILIANDO_GUIA_AUTOMATICAMENTE', true)
    try {
      await conciliacaoClient.conciliacaoExecucao.createConciliacaoExecucao(payload.createCommand)
      dispatch('conciliacaoItensCreated')
    } catch(error) {
      commit('confirmMessage/showConfirmMessage', payload.modalParams, { root: true })
    } finally {
      commit('SET_CONCILIANDO_GUIA_AUTOMATICAMENTE', false)
    }
  },
  async conciliacaoGuiaCreated ({ dispatch }) {
    dispatch('getConciliacaoGuias')
    dispatch('getFaturamentoGuias')
  },
  async conciliacaoGuiaDeleted ({ dispatch }) {
    dispatch('getConciliacaoGuias')
    dispatch('getFaturamentoGuias')
  },
  async pagamentoItensInvalidated ({ commit, dispatch }) {
    await dispatch('getPagamentoGuia')
    await dispatch('getPagamentoItens')
    await dispatch('getFaturamentoItens')
    commit('DESELECT_ALL_PAGAMENTO_ITENS')
    commit('DESELECT_ALL_FATURAMENTO_ITENS')
  },
  async pagamentoItensTipoRegistroUpdated ({ commit, dispatch }) {
    await dispatch('getPagamentoGuia')
    await dispatch('getPagamentoItens')
    await dispatch('getFaturamentoItens')
    commit('DESELECT_ALL_PAGAMENTO_ITENS')
    commit('DESELECT_ALL_FATURAMENTO_ITENS')
  },
  async getConciliacaoGuias ({ commit, state }) {
    commit('GET_CONCILIACAO_GUIAS_LOADING')

    try {
      const conciliacaoGuiasPage = await conciliacaoClient.conciliacaoGuia.getConciliacaoGuiasPage({
        pagamentoGuiaId: state.pagamentoGuiaId,
        pageSize: 100
      })

      commit('GET_CONCILIACAO_GUIAS_SUCCESS', conciliacaoGuiasPage)
    } catch (error) {
      commit('GET_CONCILIACAO_GUIAS_ERROR')
    }
  },
  async getFaturamentoGuias ({ commit, state }) {
    commit('GET_FATURAMENTO_GUIAS_LOADING')

    const pagamentoGuia = state.pagamentoGuia.result

    if (!pagamentoGuia ||
        !pagamentoGuia.prestadorId ||
        !pagamentoGuia.operadoraAnsId
    ) {
      commit('GET_FATURAMENTO_GUIAS_SUCCESS', undefined)
    }

    const userFiltersCount = Object.values(state.faturamentoGuiasFilters)
      .filter(value => Boolean(value))
      .length

    const params = {
      ...state.faturamentoGuiasFilters,
      pageSize: 100,
      prestadorId: pagamentoGuia.prestadorId,
      operadoraAnsId: pagamentoGuia.operadoraAnsId,
      includeLote: true,
      includeCronograma: true,
      sorting: state.faturamentoGuiasSorting
        .filter(sort => sort.value)
        .map(mapSortingBuilderValueToParam),
      ...(userFiltersCount === 0 && { pagamentoGuiaIdSuggestions: pagamentoGuia.id })
    }

    try {
      const faturamentoGuiasPage = await conciliacaoClient.faturamentoGuia.getFaturamentoGuiasPage(params)

      commit('GET_FATURAMENTO_GUIAS_SUCCESS', faturamentoGuiasPage)
    } catch (error) {
      commit('GET_FATURAMENTO_GUIAS_ERROR', error)
    }
  },
  async getFaturamentoItens ({ commit, state }) {
    commit('GET_FATURAMENTO_ITENS_LOADING')
    const hasGuiaSelected = Object.keys(state.selectedFaturamentoGuias).length > 0

    try {
      if (hasGuiaSelected) {
        const faturamentoItensPage = await conciliacaoClient.faturamentoItem.getFaturamentoItensPage({
          ...state.faturamentoItensFilters,
          guiaIds: Object.keys(state.selectedFaturamentoGuias),
          pageSize: 10000,
          includeConciliacaoItens: true,
          includeFaturamentoEquipes: true,
          sorting: state.faturamentoItensSorting
            .filter(sort => sort.value)
            .map(mapSortingBuilderValueToParam)
        })

        commit('GET_FATURAMENTO_ITENS_SUCCESS', faturamentoItensPage)
      } else {
        commit('GET_FATURAMENTO_ITENS_SUCCESS', [])
      }
    } catch (error) {
      commit('GET_FATURAMENTO_ITENS_ERROR', error)
    }
  },
  async getPagamentoGuia ({ commit, state }) {
    commit('GET_PAGAMENTO_GUIA_LOADING')

    try {
      const pagamentoGuia = await conciliacaoClient.pagamentoGuia.getPagamentoGuiaById(
        state.pagamentoGuiaId,
        { includePagamentoLote: true }
      )
      //console.log("pagamentoGuia", pagamentoGuia.permiteSegundaConcRegular)
      commit('SET_PERMITE_SEGUNDA_CONC_REGULAR', pagamentoGuia.permiteSegundaConcRegular)


      commit('GET_PAGAMENTO_GUIA_SUCCESS', pagamentoGuia)
    } catch (error) {
      commit('GET_PAGAMENTO_GUIA_ERROR', error)
    }
  },
  async getPagamentoItens ({ commit, dispatch, getters }) {
    commit('GET_PAGAMENTO_ITENS_LOADING')

    try {
      const pagamentoItensPage = await conciliacaoClient.pagamentoItem.getPagamentoItensPage(
        getters.pagamentoItensQuery
      )

      commit('GET_PAGAMENTO_ITENS_SUCCESS', pagamentoItensPage)
      dispatch('getPagamentoItensSuccess')
    } catch (error) {
      commit('GET_PAGAMENTO_ITENS_ERROR', error)
    }
  },
  getPagamentoItensSuccess({ dispatch, getters }) {
    if (getters.isPagamentoRecurso) {
      dispatch('setSelectedFaturamentoItensFilterOption', 'todos')
    }
  },
  partialUpdateFaturamentoGuiasFilters ({ commit, dispatch }, faturamentoGuiasFilters) {
    commit('PARTIAL_UPDATE_FATURAMENTO_GUIAS_FILTERS', faturamentoGuiasFilters)
    dispatch('getFaturamentoGuias')
  },
  partialUpdateFaturamentoItensFilters ({ commit, dispatch }, faturamentoItensFilters) {
    commit('PARTIAL_UPDATE_FATURAMENTO_ITENS_FILTERS', faturamentoItensFilters)
    dispatch('getFaturamentoItens')
  },
  partialUpdatePagamentoItensFilters ({ commit, dispatch }, pagamentoItensFilters) {
    commit('PARTIAL_UPDATE_PAGAMENTO_ITENS_FILTERS', pagamentoItensFilters)
    dispatch('getPagamentoItens')
  },
  selectAllFaturamentoGuias ({ commit }) {
    commit('SELECT_ALL_FATURAMENTO_GUIAS')
  },
  selectAllFaturamentoItens ({ commit }) {
    commit('SELECT_ALL_FATURAMENTO_ITENS')
  },
  selectAllPagamentoItens ({ commit }) {
    commit('SELECT_ALL_PAGAMENTO_ITENS')
  },
  deselectAllFaturamentoGuias ({ commit }) {
    commit('DESELECT_ALL_FATURAMENTO_GUIAS')
  },
  deselectAllFaturamentoItens ({ commit }) {
    commit('DESELECT_ALL_FATURAMENTO_ITENS')
  },
  deselectAllPagamentoItens ({ commit }) {
    commit('DESELECT_ALL_PAGAMENTO_ITENS')
  },
  selectFaturamentoGuia ({ commit }, faturamentoGuia) {
    commit('SELECT_FATURAMENTO_GUIA', faturamentoGuia)
  },
  selectFaturamentoItem ({ commit }, faturamentoItem) {
    commit('SELECT_FATURAMENTO_ITEM', faturamentoItem)
  },
  selectPagamentoItem ({ commit }, pagamentoItem) {
    commit('SELECT_PAGAMENTO_ITEM', pagamentoItem)
  },
  deselectFaturamentoGuia({ commit }, faturamentoGuia) {
    commit('DESELECT_FATURAMENTO_GUIA', faturamentoGuia)
  },
  deselectFaturamentoItem({ commit }, faturamentoItem) {
    commit('DESELECT_FATURAMENTO_ITEM', faturamentoItem)
  },
  deselectPagamentoItem ({ commit }, pagamentoItem) {
    commit('DESELECT_PAGAMENTO_ITEM', pagamentoItem)
  },
  setSelectedFaturamentoGuiasFilterOption ({ commit, dispatch }, filterOption) {
    commit('SET_SELECTED_FATURAMENTO_GUIAS_FILTER_OPTION', filterOption)

    switch (filterOption) {
      case 'todos':
        dispatch('partialUpdateFaturamentoGuiasFilters', { conciliacaoItensCountEq: undefined, conciliacaoItensCountGt: undefined })
        break
      case 'conciliados':
        dispatch('partialUpdateFaturamentoGuiasFilters', { conciliacaoItensCountEq: undefined, conciliacaoItensCountGt: 0 })
        break
      case 'nao-conciliados':
        dispatch('partialUpdateFaturamentoGuiasFilters', { conciliacaoItensCountEq: 0, conciliacaoItensCountGt: undefined })
        break
      default:
        break
    }
  },
  setSelectedFaturamentoItensFilterOption ({ commit, dispatch }, filterOption) {
    commit('SET_SELECTED_FATURAMENTO_ITENS_FILTER_OPTION', filterOption)

    switch (filterOption) {
      case 'todos':
        dispatch('partialUpdateFaturamentoItensFilters', { conciliacaoItensCountEq: undefined, conciliacaoItensCountGt: undefined })
        break
      case 'conciliados':
        dispatch('partialUpdateFaturamentoItensFilters', { conciliacaoItensCountEq: undefined, conciliacaoItensCountGt: 0 })
        break
      case 'nao-conciliados':
        dispatch('partialUpdateFaturamentoItensFilters', { conciliacaoItensCountEq: 0, conciliacaoItensCountGt: undefined })
        break
      default:
        break
    }
  },
  setSelectedPagamentoItensFilterOption ({ commit, dispatch }, filterOption) {
    commit('SET_SELECTED_PAGAMENTO_ITENS_FILTER_OPTION', filterOption)

    switch (filterOption) {
      case 'todos':
        dispatch('partialUpdatePagamentoItensFilters', { conciliacaoItensCountEq: undefined, conciliacaoItensCountGt: undefined })
        break
      case 'conciliados':
        dispatch('partialUpdatePagamentoItensFilters', { conciliacaoItensCountEq: undefined, conciliacaoItensCountGt: 0 })
        break
      case 'nao-conciliados':
        dispatch('partialUpdatePagamentoItensFilters', { conciliacaoItensCountEq: 0, conciliacaoItensCountGt: undefined })
        break
      default:
        break
    }
  },
  addPagamentoItensSortingValue ({ commit }, sortingValue) {
    commit('ADD_LIST_SORTING_VALUE', { key: 'pagamentoItensSorting', sortingValue } )
  },
  removePagamentoItensSortingValueByIndex ({ commit, dispatch }, index) {
    commit('REMOVE_LIST_SORTING_VALUE_BY_INDEX', { key: 'pagamentoItensSorting', index })
    dispatch('getPagamentoItens')
  },
  updatePagamentoItensSortingValue ({ commit, dispatch }, sort) {
    commit('UPDATE_LIST_SORTING_VALUE', { key: 'pagamentoItensSorting', ...sort } )
    dispatch('getPagamentoItens')
  },
  updatePagamentoItensSortingDirection ({ commit, dispatch }, sort) {
    commit('UPDATE_LIST_SORTING_DIRECTION', { key: 'pagamentoItensSorting', ...sort })
    dispatch('getPagamentoItens')
  },
  addFaturamentoGuiasSortingValue ({ commit }, sortingValue) {
    commit('ADD_LIST_SORTING_VALUE', { key: 'faturamentoGuiasSorting', sortingValue } )
  },
  removeFaturamentoGuiasSortingValueByIndex ({ commit, dispatch }, index) {
    commit('REMOVE_LIST_SORTING_VALUE_BY_INDEX', { key: 'faturamentoGuiasSorting', index })
    dispatch('getFaturamentoGuias')
  },
  updateFaturamentoGuiasSortingValue ({ commit, dispatch }, sort) {
    commit('UPDATE_LIST_SORTING_VALUE', { key: 'faturamentoGuiasSorting', ...sort } )
    dispatch('getFaturamentoGuias')
  },
  updateFaturamentoGuiasSortingDirection ({ commit, dispatch }, sort) {
    commit('UPDATE_LIST_SORTING_DIRECTION', { key: 'faturamentoGuiasSorting', ...sort })
    dispatch('getFaturamentoGuias')
  },
  addFaturamentoItensSortingValue ({ commit }, sortingValue) {
    commit('ADD_LIST_SORTING_VALUE', { key: 'faturamentoItensSorting', sortingValue } )
  },
  removeFaturamentoItensSortingValueByIndex ({ commit, dispatch }, index) {
    commit('REMOVE_LIST_SORTING_VALUE_BY_INDEX', { key: 'faturamentoItensSorting', index })
    dispatch('getFaturamentoItens')
  },
  updateFaturamentoItensSortingValue ({ commit, dispatch }, sort) {
    commit('UPDATE_LIST_SORTING_VALUE', { key: 'faturamentoItensSorting', ...sort } )
    dispatch('getFaturamentoItens')
  },
  updateFaturamentoItensSortingDirection ({ commit, dispatch }, sort) {
    commit('UPDATE_LIST_SORTING_DIRECTION', { key: 'faturamentoItensSorting', ...sort })
    dispatch('getFaturamentoItens')
  },
}

const mutations = {
  RESET_STATE (state, initialState) {
    Object.assign(state, initialState)
  },
  GET_CONCILIACAO_GUIAS_LOADING (state) {
    state.conciliacaoGuias = { ...state.conciliacaoGuias, loading: true }
  },
  GET_CONCILIACAO_GUIAS_SUCCESS (state, conciliacaoGuias) {
    state.conciliacaoGuias = {
      loading: false,
      result: conciliacaoGuias,
      error: undefined
    }
  },
  GET_CONCILIACAO_GUIAS_ERROR (state, error) {
    state.conciliacaoGuias = {
      error,
      loading: false,
      result: undefined
    }
  },
  GET_FATURAMENTO_GUIAS_LOADING (state) {
    state.faturamentoGuias = { ...state.faturamentoGuias, loading: true }
  },
  GET_FATURAMENTO_GUIAS_SUCCESS (state, faturamentoGuias) {
    state.faturamentoGuias = {
      loading: false,
      result: faturamentoGuias,
      error: undefined
    }
  },
  GET_FATURAMENTO_GUIAS_ERROR (state, error) {
    state.faturamentoGuias = {
      error,
      loading: false,
      result: undefined
    }
  },
  GET_FATURAMENTO_ITENS_LOADING (state) {
    state.faturamentoItens = { ...state.faturamentoItens, loading: true }
  },
  GET_FATURAMENTO_ITENS_SUCCESS (state, faturamentoItens) {
    state.faturamentoItens = {
      loading: false,
      result: faturamentoItens,
      error: undefined
    }
  },
  GET_FATURAMENTO_ITENS_ERROR (state, error) {
    state.faturamentoItens = {
      error,
      loading: false,
      result: undefined
    }
  },
  GET_PAGAMENTO_GUIA_LOADING (state) {
    state.pagamentoGuia = { ...state.pagamentoGuia, loading: true }
  },
  GET_PAGAMENTO_GUIA_SUCCESS (state, pagamentoGuia) {
    state.pagamentoGuia = {
      loading: false,
      result: pagamentoGuia,
      error: undefined
    }
  },
  GET_PAGAMENTO_GUIA_ERROR (state, error) {
    state.pagamentoGuia = {
      error,
      loading: false,
      result: undefined,
    }
  },
  GET_PAGAMENTO_ITENS_LOADING (state) {
    state.pagamentoItens = { ...state.pagamentoItens, loading: true }
  },
  GET_PAGAMENTO_ITENS_SUCCESS (state, pagamentoItens) {
    state.pagamentoItens = {
      loading: false,
      result: pagamentoItens,
      error: undefined
    }
  },
  GET_PAGAMENTO_ITENS_ERROR (state, error) {
    state.pagamentoItens = {
      error,
      loading: false,
      result: undefined,
    }
  },
  PARTIAL_UPDATE_FATURAMENTO_GUIAS_FILTERS (state, faturamentoGuiasFilters) {
    state.faturamentoGuiasFilters = { ...state.faturamentoGuiasFilters, ...faturamentoGuiasFilters }
  },
  PARTIAL_UPDATE_FATURAMENTO_ITENS_FILTERS (state, faturamentoItensFilters) {
    state.faturamentoItensFilters = { ...state.faturamentoItensFilters, ...faturamentoItensFilters }
  },
  PARTIAL_UPDATE_PAGAMENTO_ITENS_FILTERS (state, pagamentoItensFilters) {
    state.pagamentoItensFilters = { ...state.pagamentoItensFilters, ...pagamentoItensFilters }
  },
  SELECT_ALL_FATURAMENTO_GUIAS (state) {
    const guiasEntries = new Map(state.faturamentoGuias.result?.data.map(guia => [guia.id, guia]))

    state.selectedFaturamentoGuias = Object.fromEntries(guiasEntries)
  },
  SELECT_ALL_FATURAMENTO_ITENS (state) {
    const itemsEntries = new Map(state.faturamentoItens.result?.data.map(item => [item.id, item]))

    state.selectedFaturamentoItens = Object.fromEntries(itemsEntries)
  },
  SELECT_ALL_PAGAMENTO_ITENS (state) {
    const itemsEntries = new Map(state.pagamentoItens.result?.data.map(item => [item.id, item]))

    state.selectedPagamentoItens = Object.fromEntries(itemsEntries)
  },
  DESELECT_ALL_FATURAMENTO_GUIAS (state) {
    state.selectedFaturamentoGuias = {}
  },
  DESELECT_ALL_FATURAMENTO_ITENS (state) {
    state.selectedFaturamentoItens = {}
  },
  DESELECT_ALL_PAGAMENTO_ITENS (state) {
    state.selectedPagamentoItens = {}
  },
  SELECT_FATURAMENTO_GUIA (state, faturamentoGuia) {
    state.selectedFaturamentoGuias = { ...state.selectedFaturamentoGuias, [faturamentoGuia.id]: faturamentoGuia }
  },
  SELECT_FATURAMENTO_ITEM (state, faturamentoItem) {
    state.selectedFaturamentoItens = { ...state.selectedFaturamentoItens, [faturamentoItem.id]: faturamentoItem }
  },
  SELECT_PAGAMENTO_ITEM (state, pagamentoItem) {
    state.selectedPagamentoItens = { ...state.selectedPagamentoItens, [pagamentoItem.id]: pagamentoItem }
  },
  DESELECT_FATURAMENTO_GUIA (state, faturamentoGuia) {
    const { [faturamentoGuia.id]: deselectedGuia, ...selectedGuias } = state.selectedFaturamentoGuias

    state.selectedFaturamentoGuias = selectedGuias
  },
  DESELECT_FATURAMENTO_ITEM (state, faturamentoItem) {
    const { [faturamentoItem.id]: deselectedItem, ...selectedItems } = state.selectedFaturamentoItens

    state.selectedFaturamentoItens = selectedItems
  },
  DESELECT_PAGAMENTO_ITEM (state, pagamentoItem) {
    const { [pagamentoItem.id]: deselectedItem, ...selectedItems } = state.selectedPagamentoItens

    state.selectedPagamentoItens = selectedItems
  },
  //
  SET_PERMITE_SEGUNDA_CONC_REGULAR (state, valor) {  
    state.permiteSegundaConcRegular = valor
  },
  SET_CONCILIANDO_GUIA_AUTOMATICAMENTE (state, loading) {
    state.conciliandoGuiaAutomaticamente = loading
  },
  SET_PAGAMENTO_GUIA_ID (state, pagamentoGuiaId) {
    state.pagamentoGuiaId = pagamentoGuiaId
  },
  SET_PAGAMENTO_LOTE_ID (state, pagamentoLoteId) {
    state.pagamentoLoteId = pagamentoLoteId
  },
  SET_PAGAMENTO_ID (state, pagamentoId) {
    state.pagamentoId = pagamentoId
  },
  SET_SELECTED_FATURAMENTO_GUIAS (state, selectedGuias) {
    state.selectedFaturamentoGuias = selectedGuias
  },
  SET_SELECTED_FATURAMENTO_GUIAS_FILTER_OPTION (state, filterOption) {
    state.selectedFaturamentoGuiasFilterOption = filterOption
  },
  SET_SELECTED_FATURAMENTO_ITENS_FILTER_OPTION (state, filterOption) {
    state.selectedFaturamentoItensFilterOption = filterOption
  },
  SET_SELECTED_PAGAMENTO_ITENS_FILTER_OPTION (state, filterOption) {
    state.selectedPagamentoItensFilterOption = filterOption
  },
  SET_SHOW_FATURAMENTO_ITENS (state, value) {
    state.showFaturamentoItens = value
  },
  ADD_LIST_SORTING_VALUE (state, payload) {
    const sortingValues = [...state[payload.key]]
    sortingValues.push(payload.sortingValue)
    state[payload.key] = sortingValues
  },
  REMOVE_LIST_SORTING_VALUE_BY_INDEX (state, payload) {
    const sortingValues = [...state[payload.key]]
    sortingValues.splice(payload.index, 1)
    state[payload.key] = sortingValues
  },
  UPDATE_LIST_SORTING_VALUE (state, payload) {
    const sortingValues = [...state[payload.key]]
    sortingValues[payload.index].value = payload.value
    state[payload.key] = sortingValues
  },
  UPDATE_LIST_SORTING_DIRECTION (state, payload) {
    const sortingValues = [...state[payload.key]]
    sortingValues[payload.index].direction = payload.direction
    state[payload.key] = sortingValues
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
